'use client';

import { getCookie } from 'cookies-next/client';
import Script from 'next/script';
import { useEffect } from 'react';

import { AnyObject } from '@sola/schema/dotcom/helpers.ts';

import { oneTrust } from '../lib/consent.ts';

declare global {
  interface Window {
    dataLayer: AnyObject[];
  }
}

const gtag = (...args: unknown[]) => {
  window.dataLayer.push(args);
};

export const OneTrustScripts: React.FC<{
  testMode?: boolean;
}> = ({ testMode = false }) => {
  const OptanonConsent = getCookie('OptanonConsent');
  const inlineCurrentAgreement = `const cookieList = Object.fromEntries(document.cookie.split(';').map((element) => {return element.trimStart().replace('=', '~first-equal-symbol~').split('~first-equal-symbol~', 2);}),);const exists = Object.prototype.hasOwnProperty.call(cookieList, "OptanonAlertBoxClosed");window.initialAgreement = window.initialAgreement || '';if (exists) {window.initialAgreement = cookieList["OptanonAlertBoxClosed"];}`;
  const inlineOnetrust = `function OptanonWrapper() {const cookieList = Object.fromEntries(document.cookie.split(';').map((element) => {return element.trimStart().replace('=', '~first-equal-symbol~').split('~first-equal-symbol~', 2);}),);const exists = Object.prototype.hasOwnProperty.call(cookieList, "OptanonAlertBoxClosed");let updatedAgreement ='';if (exists) {updatedAgreement = cookieList["OptanonAlertBoxClosed"];} if(updatedAgreement && window.initialAgreement !== updatedAgreement && (decodeURIComponent(document.cookie).includes('C0002:0') || decodeURIComponent(document.cookie).includes('C0004:0'))){ window.location.reload()}}`;
  const inlineUpdateAgreement = `(function(document) {
    if(window.OneTrust == undefined){ return; }
    if(typeof window.OneTrust.GetDomainData == undefined){ return; }
    if(window.OneTrust.GetDomainData().Groups == undefined) { return; }
    var cookieSettings = "${OptanonConsent}";
    var otDomainGrps = JSON.parse(JSON.stringify(window.Optanon.GetDomainData().Groups));
    var cookieGroup = [];
    for(var i=0; i < otDomainGrps.length; i++){
      if(otDomainGrps[i].OptanonGroupId=='C0002' && cookieSettings.includes('C0002:0')){
        gtag('consent', 'update', {'analytics_storage': 'denied'});
        cookieGroup = cookieGroup.concat(otDomainGrps[i].FirstPartyCookies);
    document.cookie = "QuantumMetricSessionID=;expires=1990-01-01;path=/;samesite=none;domain=.compassion.com;secure;";
    document.cookie = "ci_client=;expires=1990-01-01;path=/;samesite=strict;domain=.forms.compassion.com;secure;";
    document.cookie = "ci_client=;expires=1990-01-01;path=/;samesite=strict;domain=.compassion.com;secure;";
      }
      else if(otDomainGrps[i].OptanonGroupId=='C0004'  && cookieSettings.includes('C0004:0')){
        gtag('consent', 'update', {'ad_storage': 'denied', 'ad_user_data': 'denied', 'ad_personalization': 'denied'});
        cookieGroup = cookieGroup.concat(otDomainGrps[i].FirstPartyCookies);
        document.cookie = "_fbp=;expires=1990-01-01;path=/;samesite=Lax;domain=.compassion.com;secure;";
        document.cookie = "sa-user-id=;expires=1990-01-01;samesite=;path=/";
        document.cookie = "sa-user-id-v2=;expires=1990-01-01;samesite=;path=/";
        document.cookie = "sa-user-id-v3=;expires=1990-01-01;samesite=;path=/";
      }
    }

    var plainSearchKey = [];
    var plainSearchValue = [];
    var patternSearch = [];

    for(var j=0; j < cookieGroup.length; j++){
        if(cookieGroup[j].patternKey!=null){
            cookieGroup[j].Name = new RegExp("^" + cookieGroup[j].patternKey+"\\w*$");
            patternSearch.push(cookieGroup[j]);
        }
        else{
            plainSearchKey.push(cookieGroup[j].Name);
            plainSearchValue.push(cookieGroup[j]);
        }
    }

    var cNames = document.cookie.split(';');

    for(var i=0; i<cNames.length;i++){
        cNames[i] = cNames[i].trim().split('=').shift();
        var cookieExactName = cNames[i];
        var pos = plainSearchKey.indexOf(cookieExactName);
        if(pos != -1){
            clearCookie(cookieExactName, plainSearchValue[pos].Host);
        }
    }

    cNames = document.cookie.split(';');

    for(var i=0; i<cNames.length;i++){
        var temp = cNames[i].trim().split('=');
        if(temp.length>2 || temp[1] != ''){
            var cookieExactName = temp.shift();
            var cookieOnClearList = patternSearch.find(function(cookieInfo){return cookieInfo.Name.test(cookieExactName)});
            if(cookieOnClearList){
                clearCookie(cookieExactName, cookieOnClearList.Host);
            }
        }

    }

    cNames = document.cookie.split(';');

    for(var i=0; i<cNames.length;i++){
        var temp = cNames[i].trim().split('=');
        if(temp.length>2 || temp[1] != ''){
            var cookieExactName = temp.shift();
            var pos = plainSearchKey.indexOf(cookieExactName);
            if(pos != -1){
                clearCookieNone(cookieExactName);
            }
        }
    }

    function clearCookie(cname, cdomanin){
    document.cookie = cname + "=;expires=1990-01-01;path=/;samesite=strict;domain=" + cdomanin + ";secure;";
    }


    function clearCookieNone(cname){
    document.cookie = cname + "=;expires=1990-01-01;path=/;samesite=strict;domain=" + window.location.hostname + ";secure;";
    }
    })(document);
  `;

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const getDefaultPermissions = () => {
      let permAnalytics = 'granted';
      let permAds = 'granted';
      if (
        getCookie('OptanonConsent')?.includes(
          oneTrust.targetingCookiesOptOut,
        ) &&
        getCookie('OptanonAlertBoxClosed')
      ) {
        permAds = 'denied';
      }
      if (
        getCookie('OptanonConsent')?.includes(
          oneTrust.peformanceCookiesOptOut,
        ) &&
        getCookie('OptanonAlertBoxClosed')
      ) {
        permAnalytics = 'denied';
      }
      return {
        analytics_storage: permAnalytics,
        ad_storage: permAds,
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted',
        ad_user_data: permAds,
        ad_personalization: permAds,
      };
    };
    gtag('consent', 'default', getDefaultPermissions());
  });

  return (
    <>
      <Script
        strategy="lazyOnload"
        src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
        data-domain-script={`1ba5975d-2070-4418-9c3b-6b9e65f15036${testMode ? '-test' : ''}`}
      />
      <Script strategy="lazyOnload" id="current-agreement">
        {inlineCurrentAgreement}
      </Script>
      <Script strategy="lazyOnload" id="onetrust-cookie-script">
        {inlineOnetrust}
      </Script>
      <Script strategy="lazyOnload" id="update-agreement">
        {inlineUpdateAgreement}
      </Script>
    </>
  );
};
